export default {
      id: "nav-products-usage",
      viewBox: "0 0 20 24",
      url: __webpack_public_path__ + "icons.svg#nav-products",
      toString: function () {
        return this.url;
      }
    }